{
  "instances": {
    "configprops": {
      "label": "設定屬性",

      "no_properties_set": "未設定屬性"
    }
  }
}
